var _g, _g2, _g3, _g4, _g5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "city",
    xmlns: "http://www.w3.org/2000/svg",
    width: 350.001,
    height: 278.92,
    viewBox: "0 0 350.001 278.92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "freepik--house-5--inject-51",
    transform: "translate(40.121 10.281)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26",
    "data-name": "Rectangle 26",
    width: 49.654,
    height: 20.047,
    transform: "translate(39.021)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    "data-name": "Group 24",
    transform: "translate(39.021)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27",
    "data-name": "Rectangle 27",
    width: 49.654,
    height: 20.047
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_28",
    "data-name": "Rectangle 28",
    width: 49.654,
    height: 20.047,
    transform: "translate(56.814)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_25",
    "data-name": "Group 25",
    transform: "translate(56.814)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29",
    "data-name": "Rectangle 29",
    width: 49.654,
    height: 20.047
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30",
    "data-name": "Rectangle 30",
    width: 90.361,
    height: 249.133,
    transform: "translate(0 19.109)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_26",
    "data-name": "Group 26",
    transform: "translate(0 19.109)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31",
    "data-name": "Rectangle 31",
    width: 34.206,
    height: 249.133
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_32",
    "data-name": "Rectangle 32",
    width: 90.361,
    height: 249.133,
    transform: "translate(58.212 19.109)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_27",
    "data-name": "Group 27",
    transform: "translate(34.206 19.109)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_33",
    "data-name": "Rectangle 33",
    width: 114.367,
    height: 249.133
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M211.178,135.4c0,.135-16.088.234-35.919.234s-35.919-.1-35.919-.234,16.079-.234,35.919-.234S211.178,135.278,211.178,135.4Z",
    transform: "translate(-100.544 -116.241)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_34",
    "data-name": "Rectangle 34",
    width: 30.427,
    height: 70.765,
    transform: "translate(50.6 36.469)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M182.831,225.347v-5.321c0-3.445,0-8.441-.063-14.717,0-12.553-.063-30.211-.108-50.727l.225.225H152.4l.234-.234c0,27.577-.054,52.566-.072,70.765l-.162-.162,22.212.09h6.141l-6.033.045-22.32.09h-.171v-.171c0-18.2,0-43.188-.063-70.765v-.234h30.887v.225c0,20.579-.081,38.291-.108,50.88,0,6.25-.045,11.227-.063,14.663v4.9A2,2,0,0,1,182.831,225.347Z",
    transform: "translate(-101.804 -118.113)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M183.3,170.644c0,.135-7.016.234-15.664.234s-15.673-.1-15.673-.234,7.016-.234,15.673-.234S183.3,170.518,183.3,170.644Z",
    transform: "translate(-101.783 -119.701)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M169.634,226.451c-.126,0-.234-12.436-.234-27.776s.108-27.776.234-27.776.234,12.436.234,27.776S169.761,226.451,169.634,226.451Z",
    transform: "translate(-103.496 -119.749)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_35",
    "data-name": "Rectangle 35",
    width: 30.427,
    height: 70.765,
    transform: "translate(105.493 36.469)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M243.664,225.347v-5.321c0-3.445,0-8.441-.063-14.717,0-12.553-.063-30.211-.108-50.727l.225.225H213.273l.234-.234c0,27.577-.054,52.566-.072,70.765l-.162-.162,22.212.09h6.132l-6.033.045-22.311.09H213.1v-.171c0-18.2-.045-43.188-.072-70.765v-.234h30.9v.225c0,20.579-.081,38.291-.108,50.88,0,6.25,0,11.227-.063,14.663v4.9A1.264,1.264,0,0,1,243.664,225.347Z",
    transform: "translate(-107.78 -118.113)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M244.168,170.644c0,.135-7.016.234-15.673.234s-15.664-.1-15.664-.234,7.016-.234,15.664-.234S244.168,170.518,244.168,170.644Z",
    transform: "translate(-107.76 -119.701)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M230.5,226.451c-.135,0-.234-12.436-.234-27.776s.1-27.776.234-27.776.234,12.436.234,27.776S230.631,226.451,230.5,226.451Z",
    transform: "translate(-109.473 -119.749)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_36",
    "data-name": "Rectangle 36",
    width: 30.427,
    height: 70.765,
    transform: "translate(50.6 122.628)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M182.831,320.9v-5.33c0-3.445,0-8.441-.063-14.717,0-12.544-.063-30.211-.108-50.727l.225.225H152.4l.234-.234c0,27.577-.054,52.566-.072,70.774l-.162-.171,22.212.09,6.078.045h.063l-6.033.045-22.32.09h-.171v-.162c0-18.207,0-43.2-.063-70.774v-.234h30.887v.216c0,20.579-.081,38.291-.108,50.88,0,6.25-.045,11.228-.063,14.663v4.9A1.628,1.628,0,0,1,182.831,320.9Z",
    transform: "translate(-101.804 -127.499)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M183.3,266.184c0,.135-7.016.234-15.664.234s-15.673-.1-15.673-.234,7.016-.234,15.673-.234S183.3,266.058,183.3,266.184Z",
    transform: "translate(-101.783 -129.083)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M169.634,321.951c-.126,0-.234-12.436-.234-27.776s.108-27.776.234-27.776.234,12.436.234,27.776S169.761,321.951,169.634,321.951Z",
    transform: "translate(-103.496 -129.127)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_37",
    "data-name": "Rectangle 37",
    width: 30.427,
    height: 70.765,
    transform: "translate(105.493 122.628)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M243.664,320.9v-5.33c0-3.445,0-8.441-.063-14.717,0-12.544-.063-30.211-.108-50.727l.225.225H213.273l.234-.234c0,27.577-.054,52.566-.072,70.774l-.162-.171,22.212.09,6.069.045h.063l-6.033.045-22.311.09H213.1v-.162c0-18.207-.045-43.2-.072-70.774v-.234h30.9v.216c0,20.579-.081,38.291-.108,50.88,0,6.25,0,11.228-.063,14.663v4.9A1.039,1.039,0,0,1,243.664,320.9Z",
    transform: "translate(-107.78 -127.499)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M244.168,266.184c0,.135-7.016.234-15.673.234s-15.664-.1-15.664-.234,7.016-.234,15.664-.234S244.168,266.058,244.168,266.184Z",
    transform: "translate(-107.76 -129.083)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M230.5,321.951c-.135,0-.234-12.436-.234-27.776s.1-27.776.234-27.776.234,12.436.234,27.776S230.631,321.951,230.5,321.951Z",
    transform: "translate(-109.473 -129.127)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M197.689,405.459V401.22c0-2.75,0-6.727-.063-11.723,0-9.992-.063-24.078-.1-40.482l.216.216H170.688c-.054.045.442-.442.234-.225v56.471l-.171-.171,19.723.09h5.483l-5.411.045-19.84.09h-.171v-.171c0-7.359,0-16.007-.045-25.548V349.023l.234-.243h27.189v.2c-.045,16.467-.081,30.6-.108,40.635,0,4.969-.045,8.928-.063,11.669v3.878A1.244,1.244,0,0,1,197.689,405.459Z",
    transform: "translate(-103.603 -137.216)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M227.667,405.44a1.808,1.808,0,0,1,0-.289V401.2c0-2.75,0-6.727-.063-11.723,0-9.992-.063-24.078-.108-40.482l.225.216H200.667c-.063.045.442-.442.225-.225v56.435l-.171-.171,19.723.09h5.474l-5.357.045-19.84.09h-.171V405.3c0-7.359,0-16.007-.045-25.548V348.833c-.207.207.28-.3.243-.243h27.244v.37c-.045,16.467-.081,30.6-.108,40.635,0,4.969-.045,8.928-.054,11.669v3.878A2.462,2.462,0,0,1,227.667,405.44Z",
    transform: "translate(-106.545 -137.197)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M204.519,379.269c-.054,0,.352-.361,1-.09a1.109,1.109,0,0,1,.676.974,1.235,1.235,0,0,1-.794,1.235,1.208,1.208,0,0,1-1.371-.514.992.992,0,0,1,.081-1.19.956.956,0,0,1,.694-.37c.189,0,.28.054.271.081a.958.958,0,0,0-.694.487.649.649,0,0,0,0,.757.794.794,0,0,0,.9.307.839.839,0,0,0,.514-.776.785.785,0,0,0-.4-.694A2.332,2.332,0,0,0,204.519,379.269Z",
    transform: "translate(-106.881 -140.191)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M193.93,379.269c-.045,0,.352-.361,1.01-.09a1.127,1.127,0,0,1,.676.974,1.254,1.254,0,0,1-.794,1.235,1.208,1.208,0,0,1-1.38-.514,1.01,1.01,0,0,1,.09-1.19.956.956,0,0,1,.694-.37c.189,0,.28.054.271.081a.943.943,0,0,0-.694.487.667.667,0,0,0,0,.758.821.821,0,0,0,.9.307.9.9,0,0,0,.514-.776.8.8,0,0,0-.4-.694A2.3,2.3,0,0,0,193.93,379.269Z",
    transform: "translate(-105.842 -140.191)",
    fill: "#263238"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--house-4--inject-51",
    transform: "translate(256.14)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_38",
    "data-name": "Rectangle 38",
    width: 65.859,
    height: 278.505,
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_39",
    "data-name": "Rectangle 39",
    width: 20.02,
    height: 38.57,
    transform: "translate(12.274 19.515)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M361.164,163c-.126,0-.234-8.639-.234-19.29s.108-19.29.234-19.29.234,8.639.234,19.29S361.291,163,361.164,163Z",
    transform: "translate(-338.322 -104.905)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M369.481,139.254c0,.135-4.509.234-10,.234s-10.01-.1-10.01-.234,4.509-.234,10.01-.234S369.481,139.128,369.481,139.254Z",
    transform: "translate(-337.196 -106.338)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M369.582,154.554c0,.126-4.509.234-10.091.234s-10.091-.108-10.091-.234,4.509-.234,10.091-.234S369.582,154.428,369.582,154.554Z",
    transform: "translate(-337.19 -107.841)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_40",
    "data-name": "Rectangle 40",
    width: 47.985,
    height: 278.505,
    transform: "translate(45.875)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    d: "M434.7,381.356l-48.157-.144V103.59h47.985Z",
    transform: "translate(-340.836 -102.86)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_41",
    "data-name": "Rectangle 41",
    width: 20.02,
    height: 38.57,
    transform: "translate(59.573 19.515)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M413.624,163c-.135,0-.234-8.639-.234-19.29s.1-19.29.234-19.29.234,8.639.234,19.29S413.751,163,413.624,163Z",
    transform: "translate(-343.473 -104.905)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M421.94,139.254c0,.135-4.509.234-10.01.234s-10.01-.1-10.01-.234,4.509-.234,10.01-.234S421.94,139.128,421.94,139.254Z",
    transform: "translate(-342.347 -106.338)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M422.042,154.554c0,.126-4.509.234-10.091.234s-10.091-.108-10.091-.234,4.509-.234,10.091-.234S422.042,154.428,422.042,154.554Z",
    transform: "translate(-342.341 -107.841)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_42",
    "data-name": "Rectangle 42",
    width: 20.02,
    height: 38.57,
    transform: "translate(59.573 66.977)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    d: "M413.624,215.62c-.135,0-.234-8.63-.234-19.281s.1-19.29.234-19.29.234,8.63.234,19.29S413.751,215.62,413.624,215.62Z",
    transform: "translate(-343.473 -110.073)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M421.94,191.884c0,.126-4.509.234-10.01.234s-10.01-.108-10.01-.234,4.509-.234,10.01-.234S421.94,191.749,421.94,191.884Z",
    transform: "translate(-342.347 -111.506)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M422.042,207.184c0,.126-4.509.234-10.091.234s-10.091-.108-10.091-.234,4.509-.234,10.091-.234S422.042,207.049,422.042,207.184Z",
    transform: "translate(-342.341 -113.009)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_43",
    "data-name": "Rectangle 43",
    width: 45.514,
    height: 278.505,
    opacity: 0.3
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--house-3--inject-51",
    transform: "translate(187.125 55.831)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M307.191,185.4a2.651,2.651,0,0,1,.081,2.02,3.9,3.9,0,0,0-.2,2.047c.117.433.406.8.523,1.235a1.8,1.8,0,0,1-1.01,2.137l-3.607-1.632a13.943,13.943,0,0,0,1.731-5.23",
    transform: "translate(-263.616 -166.724)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_28",
    "data-name": "Group 28",
    transform: "translate(39.364 18.676)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M307.191,185.4a2.651,2.651,0,0,1,.081,2.02,3.9,3.9,0,0,0-.2,2.047c.117.433.406.8.523,1.235a1.8,1.8,0,0,1-1.01,2.137l-3.607-1.632a13.943,13.943,0,0,0,1.731-5.23",
    transform: "translate(-302.98 -185.4)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M296.408,184.314c1.073.253-.712,2.056-.631,3.156a6.746,6.746,0,0,1-.2,3.265,13.662,13.662,0,0,1-6.259-1.425c.5-2.137,1-4.284,1.506-6.43C290.835,182.88,295.452,184.088,296.408,184.314Z",
    transform: "translate(-262.275 -166.476)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_44",
    "data-name": "Rectangle 44",
    width: 33.033,
    height: 47.742,
    transform: "translate(58.825)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_45",
    "data-name": "Rectangle 45",
    width: 33.033,
    height: 47.742,
    transform: "translate(88.539)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M383.741,203.945a4.434,4.434,0,0,1,0-.541v-1.515c0-1.353,0-3.265-.063-5.645,0-4.834-.063-11.6-.108-19.506l.225.225H368.807c-.063.045.442-.442.225-.234h0v14.826c0,4.59,0,8.784-.045,12.409l-.18-.18,10.9.1,3.012.045h.072l-3.012.072-11.011.1H368.6V176.683h0l.243-.243h15.2v.216c-.045,7.972-.081,14.781-.108,19.65,0,2.363-.045,4.257-.054,5.591v1.479a3.021,3.021,0,0,1-.144.568Z",
    transform: "translate(-270.059 -165.844)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M381.994,193.465c0,.063-.18.18-.225.478a.433.433,0,0,0,.577.523.424.424,0,0,0,.117-.767c-.216-.207-.451-.162-.469-.234s.234-.262.658,0a.8.8,0,0,1-.153,1.488.8.8,0,0,1-1.046-1.064C381.642,193.411,382,193.4,381.994,193.465Z",
    transform: "translate(-271.315 -167.502)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M414.912,207.2v-2.471c0-1.65,0-4.049-.054-7.214l.108.108c-14.005.072-43.287.126-77.159.126-34.783,0-64.786-.054-78.457-.135l.1-.1c0,2.705,0,4.807-.045,6.25v-6.349h.1c13.635-.081,43.638-.135,78.457-.135,33.836,0,63.127.054,77.159.126h-.072v.108c0,3.129-.045,5.528-.054,7.214v1.849A1.685,1.685,0,0,1,414.912,207.2Z",
    transform: "translate(-259.332 -167.89)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M264.831,207a22.959,22.959,0,0,1-.234-4.59,22.96,22.96,0,0,1,.234-4.59,22.188,22.188,0,0,1,.234,4.59A22.185,22.185,0,0,1,264.831,207Z",
    transform: "translate(-259.844 -167.943)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M271.441,207a22.964,22.964,0,0,1-.234-4.59,22.96,22.96,0,0,1,.234-4.59,22.96,22.96,0,0,1,.234,4.59,22.96,22.96,0,0,1-.234,4.59Z",
    transform: "translate(-260.493 -167.943)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M284.019,204.8a3.058,3.058,0,0,1-.045-.586v-1.668c0-1.506,0-3.607-.072-6.186,0-5.285-.054-12.544-.081-20.742l.234.225H278.1l.225-.234c0,8.116-.054,15.4-.072,20.678,0,2.579-.054,4.671-.072,6.168,0,.694,0,1.245-.045,1.668a3.8,3.8,0,0,1,0,.586,2.334,2.334,0,0,1-.045-.586v-1.668c0-1.5-.045-3.607-.072-6.168,0-5.276,0-12.535-.072-20.678v-.234h6.43v.243c0,8.116-.054,15.412-.072,20.742,0,2.588-.054,4.68-.072,6.186v1.668a3.057,3.057,0,0,1-.217.586Z",
    transform: "translate(-261.158 -165.739)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M291.261,207a22.181,22.181,0,0,1-.234-4.59,22.183,22.183,0,0,1,.234-4.59,22.958,22.958,0,0,1,.234,4.59,22.957,22.957,0,0,1-.234,4.59Z",
    transform: "translate(-262.439 -167.943)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M297.861,207a22.957,22.957,0,0,1-.234-4.59,22.957,22.957,0,0,1,.234-4.59,22.186,22.186,0,0,1,.234,4.59A22.183,22.183,0,0,1,297.861,207Z",
    transform: "translate(-263.088 -167.943)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M304.471,207a22.964,22.964,0,0,1-.234-4.59,22.962,22.962,0,0,1,.234-4.59,22.957,22.957,0,0,1,.234,4.59,22.957,22.957,0,0,1-.234,4.59Z",
    transform: "translate(-263.737 -167.943)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M311.081,207a22.183,22.183,0,0,1-.234-4.59,22.186,22.186,0,0,1,.234-4.59,22.958,22.958,0,0,1,.234,4.59,22.957,22.957,0,0,1-.234,4.59Z",
    transform: "translate(-264.385 -167.943)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M317.681,207a22.959,22.959,0,0,1-.234-4.59,22.96,22.96,0,0,1,.234-4.59,22.188,22.188,0,0,1,.234,4.59A22.183,22.183,0,0,1,317.681,207Z",
    transform: "translate(-265.034 -167.943)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M324.291,207a22.964,22.964,0,0,1-.234-4.59,22.96,22.96,0,0,1,.234-4.59,22.96,22.96,0,0,1,.234,4.59,22.96,22.96,0,0,1-.234,4.59Z",
    transform: "translate(-265.683 -167.943)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M330.9,207a21.788,21.788,0,0,1-.243-4.59,21.788,21.788,0,0,1,.243-4.59,22.96,22.96,0,0,1,.235,4.59A22.96,22.96,0,0,1,330.9,207Z",
    transform: "translate(-266.331 -167.943)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    "data-name": "Path 124",
    d: "M337.5,207a22.959,22.959,0,0,1-.234-4.59,22.96,22.96,0,0,1,.234-4.59,22.188,22.188,0,0,1,.234,4.59A22.183,22.183,0,0,1,337.5,207Z",
    transform: "translate(-266.98 -167.943)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    "data-name": "Path 125",
    d: "M344.111,207a22.183,22.183,0,0,1-.234-4.59,22.186,22.186,0,0,1,.234-4.59,22.96,22.96,0,0,1,.235,4.59,22.957,22.957,0,0,1-.234,4.59Z",
    transform: "translate(-267.629 -167.943)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    d: "M350.711,207a22.962,22.962,0,0,1-.234-4.59,22.962,22.962,0,0,1,.234-4.59,22.185,22.185,0,0,1,.234,4.59A22.185,22.185,0,0,1,350.711,207Z",
    transform: "translate(-268.277 -167.943)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    "data-name": "Path 127",
    d: "M357.321,207a22.962,22.962,0,0,1-.234-4.59,22.957,22.957,0,0,1,.234-4.59,22.962,22.962,0,0,1,.234,4.59,22.962,22.962,0,0,1-.234,4.59Z",
    transform: "translate(-268.926 -167.943)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M363.971,207a22.183,22.183,0,0,1-.234-4.59,22.186,22.186,0,0,1,.234-4.59,22.96,22.96,0,0,1,.235,4.59,22.96,22.96,0,0,1-.235,4.59Z",
    transform: "translate(-269.579 -167.943)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    d: "M370.531,207a22.957,22.957,0,0,1-.234-4.59,22.957,22.957,0,0,1,.234-4.59,22.185,22.185,0,0,1,.234,4.59A22.185,22.185,0,0,1,370.531,207Z",
    transform: "translate(-270.223 -167.943)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    d: "M377.141,207a22.183,22.183,0,0,1-.234-4.59,22.183,22.183,0,0,1,.234-4.59,22.958,22.958,0,0,1,.234,4.59,22.957,22.957,0,0,1-.234,4.59Z",
    transform: "translate(-270.872 -167.943)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M383.75,207a21.782,21.782,0,0,1-.243-4.59,21.786,21.786,0,0,1,.243-4.59,22.955,22.955,0,0,1,.235,4.59,22.957,22.957,0,0,1-.234,4.59Z",
    transform: "translate(-271.52 -167.943)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    d: "M390.351,207a22.964,22.964,0,0,1-.234-4.59,22.962,22.962,0,0,1,.234-4.59,22.185,22.185,0,0,1,.234,4.59A22.185,22.185,0,0,1,390.351,207Z",
    transform: "translate(-272.17 -167.943)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    d: "M396.971,207a22.183,22.183,0,0,1-.234-4.59,22.183,22.183,0,0,1,.234-4.59,22.958,22.958,0,0,1,.235,4.59,22.957,22.957,0,0,1-.234,4.59Z",
    transform: "translate(-272.819 -167.943)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    d: "M403.561,207a22.962,22.962,0,0,1-.234-4.59,22.962,22.962,0,0,1,.234-4.59,22.183,22.183,0,0,1,.234,4.59,22.185,22.185,0,0,1-.234,4.59Z",
    transform: "translate(-273.467 -167.943)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    d: "M410.171,207a22.962,22.962,0,0,1-.234-4.59,22.96,22.96,0,0,1,.234-4.59,22.962,22.962,0,0,1,.234,4.59,22.96,22.96,0,0,1-.234,4.59Z",
    transform: "translate(-274.116 -167.943)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    d: "M416.781,207a22.179,22.179,0,0,1-.235-4.59,22.183,22.183,0,0,1,.235-4.59,22.96,22.96,0,0,1,.234,4.59,22.96,22.96,0,0,1-.234,4.59Z",
    transform: "translate(-274.764 -167.943)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137",
    "data-name": "Path 137",
    d: "M423.381,207a22.959,22.959,0,0,1-.234-4.59,22.96,22.96,0,0,1,.234-4.59,22.186,22.186,0,0,1,.234,4.59A22.185,22.185,0,0,1,423.381,207Z",
    transform: "translate(-275.413 -167.943)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138",
    "data-name": "Path 138",
    d: "M429.971,207a22.179,22.179,0,0,1-.235-4.59,22.183,22.183,0,0,1,.234-4.59,22.96,22.96,0,0,1,.235,4.59,22.96,22.96,0,0,1-.235,4.59Z",
    transform: "translate(-276.06 -167.943)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139",
    "data-name": "Path 139",
    d: "M422.909,206.914c0,.126-18.388.234-41.059.234s-41.059-.108-41.059-.234,18.379-.234,41.059-.234S422.909,206.788,422.909,206.914Z",
    transform: "translate(-267.329 -168.813)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_46",
    "data-name": "Rectangle 46",
    width: 136.967,
    height: 184.609,
    transform: "translate(18.613 38.101)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_47",
    "data-name": "Rectangle 47",
    width: 73.461,
    height: 184.609,
    transform: "translate(0 38.101)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_48",
    "data-name": "Rectangle 48",
    width: 25.052,
    height: 25.052,
    transform: "translate(120.481 138.265)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140",
    "data-name": "Path 140",
    d: "M407.854,345.438c-.126,0-.234-6.475-.234-14.429s.108-14.429.234-14.429.234,6.475.234,14.429S407.963,345.438,407.854,345.438Z",
    transform: "translate(-273.891 -179.604)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_141",
    "data-name": "Path 141",
    d: "M422.385,327.294c0,.135-7.278.234-16.233.234s-16.233-.1-16.233-.234,7.278-.234,16.233-.234S422.385,327.168,422.385,327.294Z",
    transform: "translate(-272.153 -180.633)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_49",
    "data-name": "Rectangle 49",
    width: 25.052,
    height: 25.052,
    transform: "translate(84.752 138.265)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142",
    "data-name": "Path 142",
    d: "M368.234,345.438c-.126,0-.234-6.475-.234-14.429s.108-14.429.234-14.429.234,6.475.234,14.429S368.37,345.438,368.234,345.438Z",
    transform: "translate(-270.001 -179.604)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143",
    "data-name": "Path 143",
    d: "M382.77,327.294c0,.135-7.287.234-16.278.234s-16.233-.1-16.233-.234,7.287-.234,16.233-.234S382.77,327.168,382.77,327.294Z",
    transform: "translate(-268.259 -180.633)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_50",
    "data-name": "Rectangle 50",
    width: 25.052,
    height: 25.052,
    transform: "translate(120.481 98.685)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_144",
    "data-name": "Path 144",
    d: "M407.854,301.548c-.126,0-.234-6.475-.234-14.429s.108-14.429.234-14.429.234,6.466.234,14.429S407.963,301.548,407.854,301.548Z",
    transform: "translate(-273.891 -175.295)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_145",
    "data-name": "Path 145",
    d: "M422.385,283.414c0,.126-7.278.234-16.233.234s-16.233-.108-16.233-.234,7.278-.234,16.233-.234S422.385,283.279,422.385,283.414Z",
    transform: "translate(-272.153 -176.325)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_51",
    "data-name": "Rectangle 51",
    width: 25.052,
    height: 25.052,
    transform: "translate(84.752 98.685)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_146",
    "data-name": "Path 146",
    d: "M368.234,301.548c-.126,0-.234-6.475-.234-14.429s.108-14.429.234-14.429.234,6.466.234,14.429S368.37,301.548,368.234,301.548Z",
    transform: "translate(-270.001 -175.295)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147",
    "data-name": "Path 147",
    d: "M382.77,283.414c0,.126-7.287.234-16.278.234s-16.233-.108-16.233-.234,7.287-.234,16.233-.234S382.77,283.279,382.77,283.414Z",
    transform: "translate(-268.259 -176.325)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_52",
    "data-name": "Rectangle 52",
    width: 25.052,
    height: 25.052,
    transform: "translate(120.481 59.014)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_148",
    "data-name": "Path 148",
    d: "M407.854,257.558c-.126,0-.234-6.475-.234-14.429s.108-14.429.234-14.429.234,6.475.234,14.429S407.963,257.558,407.854,257.558Z",
    transform: "translate(-273.891 -170.975)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_149",
    "data-name": "Path 149",
    d: "M422.385,239.424c0,.126-7.278.234-16.233.234s-16.233-.108-16.233-.234,7.278-.234,16.233-.234S422.385,239.3,422.385,239.424Z",
    transform: "translate(-272.153 -172.005)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_53",
    "data-name": "Rectangle 53",
    width: 25.052,
    height: 25.052,
    transform: "translate(84.752 59.014)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    d: "M368.234,257.558c-.126,0-.234-6.475-.234-14.429s.108-14.429.234-14.429.234,6.475.234,14.429S368.37,257.558,368.234,257.558Z",
    transform: "translate(-270.001 -170.975)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    d: "M382.77,239.424c0,.126-7.287.234-16.278.234s-16.233-.108-16.233-.234,7.287-.234,16.233-.234S382.77,239.3,382.77,239.424Z",
    transform: "translate(-268.259 -172.005)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    "data-name": "Group 29",
    transform: "translate(23.249 59.014)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_54",
    "data-name": "Rectangle 54",
    width: 25.052,
    height: 25.052,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_152",
    "data-name": "Path 152",
    d: "M298.974,257.558c-.135,0-.234-6.475-.234-14.429s.1-14.429.234-14.429.234,6.475.234,14.429S299.1,257.558,298.974,257.558Z",
    transform: "translate(-263.2 -170.975)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_153",
    "data-name": "Path 153",
    d: "M314.57,239.424c0,.126-7.287.234-16.278.234s-16.233-.108-16.233-.234,7.287-.234,16.233-.234S314.57,239.3,314.57,239.424Z",
    transform: "translate(-261.562 -172.005)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_30",
    "data-name": "Group 30",
    transform: "translate(23.249 99.082)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_55",
    "data-name": "Rectangle 55",
    width: 25.052,
    height: 25.052,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_154",
    "data-name": "Path 154",
    d: "M298.974,301.978c-.135,0-.234-6.475-.234-14.429s.1-14.429.234-14.429.234,6.475.234,14.429S299.1,301.978,298.974,301.978Z",
    transform: "translate(-263.2 -175.337)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    "data-name": "Path 155",
    d: "M314.57,283.844c0,.126-7.287.234-16.278.234s-16.233-.108-16.233-.234,7.287-.234,16.233-.234S314.57,283.718,314.57,283.844Z",
    transform: "translate(-261.562 -176.367)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_31",
    "data-name": "Group 31",
    transform: "translate(23.249 139.14)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_56",
    "data-name": "Rectangle 56",
    width: 25.052,
    height: 25.052,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_156",
    "data-name": "Path 156",
    d: "M298.974,346.4c-.135,0-.234-6.466-.234-14.429s.1-14.429.234-14.429.234,6.475.234,14.429S299.1,346.4,298.974,346.4Z",
    transform: "translate(-263.2 -179.699)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_157",
    "data-name": "Path 157",
    d: "M314.57,328.264c0,.126-7.287.234-16.278.234s-16.233-.108-16.233-.234,7.287-.234,16.233-.234S314.57,328.138,314.57,328.264Z",
    transform: "translate(-261.562 -180.729)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_158",
    "data-name": "Path 158",
    d: "M397.2,406.618a.6.6,0,0,1,0-.225v-3.219c0-2.255,0-5.492-.063-9.532,0-8.116-.054-19.524-.081-32.546l.225.225H371.523l.225-.225c0,13.13-.054,24.61-.081,32.835,0,4.076-.045,7.35-.063,9.631v3.255a.606.606,0,0,1,0,.225.606.606,0,0,1,0-.225c0-.171,0-.4,0-.667v-2.588c0-2.282,0-5.555-.063-9.631,0-8.224-.054-19.7-.081-32.835v-.234h26.152v.234c0,13.022-.054,24.394-.081,32.546,0,4.04-.045,7.278-.063,9.532v3.219A.6.6,0,0,1,397.2,406.618Z",
    transform: "translate(-270.34 -183.952)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_57",
    "data-name": "Rectangle 57",
    width: 8.748,
    height: 20.949,
    transform: "translate(104.411 179.838)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_159",
    "data-name": "Path 159",
    d: "M383.883,385.084H375.09V364.09h8.793Zm-8.748-.054h8.7V364.135h-8.7Z",
    transform: "translate(-270.697 -184.27)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_58",
    "data-name": "Rectangle 58",
    width: 8.748,
    height: 20.949,
    transform: "translate(114.872 179.838)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    "data-name": "Path 160",
    d: "M395.483,385.084H386.69V364.09h8.793Zm-8.748-.054h8.7V364.135h-8.7Z",
    transform: "translate(-271.836 -184.27)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161",
    "data-name": "Path 161",
    d: "M396.48,389.725a.4.4,0,0,1,.28-.054.9.9,0,0,1,.649.469,1.307,1.307,0,0,1,.081,1.19,1.235,1.235,0,0,1-1.317.685,1.281,1.281,0,0,1-.974-1.154,1.136,1.136,0,0,1,.532-1.073c.613-.379,1.064-.108,1.019-.072a1.639,1.639,0,0,0-.821.334.83.83,0,0,0-.3.758.9.9,0,0,0,.631.712.839.839,0,0,0,.839-.424,1.01,1.01,0,0,0,0-.839C396.9,389.8,396.462,389.8,396.48,389.725Z",
    transform: "translate(-272.671 -186.773)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162",
    "data-name": "Path 162",
    d: "M424.885,360.59v-4.518l.063.063H410.33c.045-.045-.1.09.09-.1h0v4.509l-.09-.09,10.425.045H410.24v-4.581h0c.189-.189.054-.054.1-.09h14.681v4.293A.871.871,0,0,1,424.885,360.59Z",
    transform: "translate(-274.148 -183.457)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_163",
    "data-name": "Path 163",
    d: "M361.825,350.262v-4.509l.054.063H347.261c.045,0-.09.1.1-.09h0v4.482l-.09-.09,10.434.045h4.184a1.168,1.168,0,0,1-.271,0H347.18V345.59h0l.09-.09h14.681v4.293A.954.954,0,0,1,361.825,350.262Z",
    transform: "translate(-267.956 -182.444)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164",
    "data-name": "Path 164",
    d: "M351.708,309.643v-4.509l.063.054H337.153l.09-.09h0v4.509l-.09-.09h10.47l-10.488.045H337v-4.572h0l.1-.1h14.672v4.293A1.6,1.6,0,0,1,351.708,309.643Z",
    transform: "translate(-266.957 -178.457)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_165",
    "data-name": "Path 165",
    d: "M409.986,265.919V261.41l.063.054H395.431l.1-.09h0v4.482l-.09-.09h10.488l-10.488.045h-.09v-4.572h0c.189-.189.054-.054.09-.1h14.681v4.293A1.018,1.018,0,0,1,409.986,265.919Z",
    transform: "translate(-272.686 -174.16)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_166",
    "data-name": "Path 166",
    d: "M363.854,219.281v-4.527l.054.063H349.3s-.1.09.09-.1h0v4.509l-.09-.1,10.425.045H349.2V214.79h0l.1-.09h14.672v4.293C363.972,219.272,363.854,219.281,363.854,219.281Z",
    transform: "translate(-268.155 -169.601)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_167",
    "data-name": "Path 167",
    d: "M419.805,270.772v-4.518l.054.063H405.241c.045,0-.09.1.1-.09h0v4.482l-.09-.09,10.434.045h4.184a1.421,1.421,0,0,1-.271,0H405.16V266.29h0l.09-.09h14.681v4.3C419.932,270.781,419.805,270.772,419.805,270.772Z",
    transform: "translate(-273.649 -174.658)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_168",
    "data-name": "Path 168",
    d: "M344.745,314.524v-4.509l.054.054H330.18c.045,0-.09.1.1-.09h0v4.482l-.09-.09H330V309.8h0c.189-.189.054-.054.09-.1h14.681v4.293C344.772,314.263,344.745,314.524,344.745,314.524Z",
    transform: "translate(-266.269 -178.928)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_169",
    "data-name": "Path 169",
    d: "M351.708,224.252v-4.509l.063.054H337.153s-.1.09.09-.09h0v4.509l-.09-.09H347.6l-10.488.045H337v-4.581h0l.1-.1h14.672v4.293A1.7,1.7,0,0,1,351.708,224.252Z",
    transform: "translate(-266.957 -170.071)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_170",
    "data-name": "Path 170",
    d: "M430.143,365.593v-4.509l.063.063H415.588l.09-.09h0v4.509l-.09-.09,10.425.045H415.48v-4.572h0c.189-.189.054-.054.1-.09h14.672v4.293A.889.889,0,0,1,430.143,365.593Z",
    transform: "translate(-274.663 -183.951)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_171",
    "data-name": "Path 171",
    d: "M331.482,176.914a2.527,2.527,0,0,1-.46.352c-.316.216-.767.55-1.38.9a43.664,43.664,0,0,1-5.411,2.85,46.272,46.272,0,0,1-39-.577,43.027,43.027,0,0,1-5.294-3c-.6-.388-1.037-.73-1.344-.956a2.419,2.419,0,0,1-.451-.361,3.361,3.361,0,0,1,.5.289c.325.189.785.514,1.4.9a49.775,49.775,0,0,0,5.339,2.859,47.309,47.309,0,0,0,38.724.568,50.312,50.312,0,0,0,5.411-2.705c.631-.343,1.091-.649,1.425-.83a2.8,2.8,0,0,1,.55-.289Z",
    transform: "translate(-261.177 -165.812)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_172",
    "data-name": "Path 172",
    d: "M330.19,175.41a2.09,2.09,0,0,1-.4.28l-1.208.73-.9.514c-.325.18-.694.352-1.082.55a28.319,28.319,0,0,1-2.705,1.226l-1.6.64c-.559.216-1.163.379-1.8.586a40.58,40.58,0,0,1-3.968,1.073,45.09,45.09,0,0,1-18.722.126c-1.416-.325-2.76-.6-3.986-1.019-.613-.189-1.217-.352-1.8-.559l-1.605-.622a28.325,28.325,0,0,1-2.705-1.19c-.4-.189-.767-.352-1.091-.523l-.9-.514L284.5,176a1.588,1.588,0,0,1-.406-.28,2.165,2.165,0,0,1,.46.2l1.244.631.9.469c.334.162.7.316,1.1.5.794.334,1.677.776,2.705,1.118l1.605.586c.559.2,1.163.343,1.8.532,1.217.4,2.561.658,3.959.965a51.185,51.185,0,0,0,9.289.9,50.5,50.5,0,0,0,9.262-1c1.4-.334,2.705-.613,3.95-1.019.6-.2,1.2-.352,1.759-.559l1.6-.6c1.028-.361,1.9-.812,2.705-1.163.388-.18.758-.334,1.091-.505l.9-.478,1.235-.649a1.723,1.723,0,0,1,.532-.225Z",
    transform: "translate(-261.761 -165.743)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_173",
    "data-name": "Path 173",
    d: "M306.962,185.477a4.428,4.428,0,0,0-1.74,3.544,6.312,6.312,0,0,1-.388,2.516,2.705,2.705,0,0,1-2.291,1.2,7.855,7.855,0,0,1-2.633-.55,8.26,8.26,0,0,0,1.921-3.833,10.641,10.641,0,0,1,.388-1.8,2,2,0,0,1,1.19-1.281Z",
    transform: "translate(-263.315 -166.711)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_174",
    "data-name": "Path 174",
    d: "M314.67,184.827a2.48,2.48,0,0,0-1.416,1.885,10.513,10.513,0,0,0,0,2.5,4.455,4.455,0,0,1-.424,2.426,7.981,7.981,0,0,0,5.564-1.118,8.522,8.522,0,0,1,.514-6.313s.054-.126-.216-.144S314.67,184.827,314.67,184.827Z",
    transform: "translate(-264.583 -166.592)",
    fill: "#407bff"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--house-2--inject-51",
    transform: "translate(89.649 148.979)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_59",
    "data-name": "Rectangle 59",
    width: 38.336,
    height: 87.962,
    transform: "translate(8.964 41.6)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32",
    transform: "translate(8.964 41.6)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_60",
    "data-name": "Rectangle 60",
    width: 38.336,
    height: 87.962
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_175",
    "data-name": "Path 175",
    d: "M151.24,310.309h94.573l17.675-25.088,18.523,25.8,21.77-.352-23.465-31.6-100.01.415Z",
    transform: "translate(-151.24 -269.069)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33",
    transform: "translate(0 10.001)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_176",
    "data-name": "Path 176",
    d: "M151.24,310.309h94.573l17.675-25.088,18.523,25.8,21.77-.352-23.465-31.6-100.01.415Z",
    transform: "translate(-151.24 -279.07)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_177",
    "data-name": "Path 177",
    d: "M203.68,311.339V399.3h94.446V311.339H287.3L268.637,285.89l-17.73,25.061Z",
    transform: "translate(-156.389 -269.739)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_178",
    "data-name": "Path 178",
    d: "M240.591,407.473a.523.523,0,0,1,0-.189c0-.144,0-.334,0-.55v-2.146c0-1.9,0-4.608-.072-7.981,0-6.836-.045-16.359-.081-27.271l.234.225H218.578l.225-.225c0,10.912-.054,20.435-.081,27.271,0,3.373,0,6.078-.063,7.981v2.886a.767.767,0,0,1,0-.189v-.55c0-.523,0-1.235-.045-2.146,0-1.9,0-4.608-.063-7.981,0-6.836-.054-16.359-.081-27.271v-.225h22.545v.225c0,10.912-.063,20.435-.081,27.271,0,3.373-.054,6.078-.072,7.981v2.7C240.591,407.41,240.591,407.473,240.591,407.473Z",
    transform: "translate(-157.841 -277.91)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_61",
    "data-name": "Rectangle 61",
    width: 34.801,
    height: 21.553,
    transform: "translate(95.97 47.21)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_62",
    "data-name": "Rectangle 62",
    width: 21.95,
    height: 20.778,
    transform: "translate(58.473 47.399)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_179",
    "data-name": "Path 179",
    d: "M268.774,342.082c-.126,0-.234-4.87-.234-10.876s.108-10.876.234-10.876.234,4.87.234,10.876S268.955,342.082,268.774,342.082Z",
    transform: "translate(-162.758 -273.12)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_180",
    "data-name": "Path 180",
    d: "M284.824,342.082c-.126,0-.234-4.87-.234-10.876s.108-10.876.234-10.876.234,4.87.234,10.876S284.96,342.082,284.824,342.082Z",
    transform: "translate(-164.334 -273.12)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_181",
    "data-name": "Path 181",
    d: "M283.279,333.091a56.678,56.678,0,0,1-7.214.234,56.807,56.807,0,0,1-7.214-.234,54.836,54.836,0,0,1,7.214-.234,54.748,54.748,0,0,1,7.214.234Z",
    transform: "translate(-162.788 -274.347)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_182",
    "data-name": "Path 182",
    d: "M228.224,341.327c-.126,0-.234-4.653-.234-10.4s.108-10.389.234-10.389.234,4.653.234,10.389S228.36,341.327,228.224,341.327Z",
    transform: "translate(-158.776 -273.141)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_183",
    "data-name": "Path 183",
    d: "M238.03,332.6c0,.126-4.915.234-10.975.234s-10.975-.108-10.975-.234,4.915-.234,10.975-.234S238.03,332.478,238.03,332.6Z",
    transform: "translate(-157.607 -274.303)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_184",
    "data-name": "Path 184",
    d: "M279.8,304a4.653,4.653,0,1,1-1.36-3.3A4.653,4.653,0,0,1,279.8,304Z",
    transform: "translate(-162.949 -271.059)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_185",
    "data-name": "Path 185",
    d: "M238.141,295.493l5.871-7.251V270.82H231.72v24.809Z",
    transform: "translate(-159.143 -268.259)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_34",
    "data-name": "Group 34",
    transform: "translate(78.998 2.561)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_186",
    "data-name": "Path 186",
    d: "M238.84,295.493V270.82h5.871v17.423Z",
    transform: "translate(-238.84 -270.82)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_63",
    "data-name": "Rectangle 63",
    width: 14.501,
    height: 2.561,
    transform: "translate(71.207)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_187",
    "data-name": "Path 187",
    d: "M151.24,313.707v2.552h94.518V313.68Z",
    transform: "translate(-151.24 -272.467)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_188",
    "data-name": "Path 188",
    d: "M256.05,313.53l17.675-24.818.054-2.823L256.1,310.978Z",
    transform: "translate(-161.532 -269.739)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_64",
    "data-name": "Rectangle 64",
    width: 21.174,
    height: 1.641,
    transform: "translate(130.915 41.6)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_65",
    "data-name": "Rectangle 65",
    width: 7.81,
    height: 2.967,
    transform: "translate(67.383 85.582)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_189",
    "data-name": "Path 189",
    d: "M240.707,390.54c-.072,0-.054-.5-.577-.9a1.091,1.091,0,0,0-1.01-.108,1.046,1.046,0,0,0,0,1.948,1.091,1.091,0,0,0,1.01-.117c.523-.37.505-.9.577-.857s.225.541-.388,1.109a1.389,1.389,0,0,1-1.344.243,1.434,1.434,0,0,1,0-2.705,1.389,1.389,0,0,1,1.344.243C240.933,389.99,240.752,390.576,240.707,390.54Z",
    transform: "translate(-159.761 -279.871)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_190",
    "data-name": "Path 190",
    d: "M219.983,352.868a1.807,1.807,0,0,1,0-.271V348.99l.063.063H207.421c.045-.045-.09.09.09-.1h0v3.86l-.09-.09h-.081V348.99h0l.09-.09H220.11v3.715C220.11,352.832,219.983,352.868,219.983,352.868Z",
    transform: "translate(-156.749 -275.926)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_191",
    "data-name": "Path 191",
    d: "M173.75,339.459v-3.878l.054.063H161.233c0-.045-.1.09.09-.1h0v3.86l-.09-.09h12.319a1.113,1.113,0,0,1,.253,0h-3.526l-9.018.045h-.09v-3.95h0l.1-.09H173.9V339a1.308,1.308,0,0,1-.153.46Z",
    transform: "translate(-152.215 -274.592)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_192",
    "data-name": "Path 192",
    d: "M182.1,335.149a1.54,1.54,0,0,1,0-.271v-3.6l.063.063h-12.58s-.09.1.1-.09h0v3.842l-.09-.09,8.973.045H169.51v-3.941h0c.189-.189.054-.054.09-.1h12.643V334.7A2.254,2.254,0,0,1,182.1,335.149Z",
    transform: "translate(-153.034 -274.168)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_193",
    "data-name": "Path 193",
    d: "M224.513,357.149v-3.878l.063.063H212l.1-.1h0v3.86l-.09-.09h12.328a1.109,1.109,0,0,1,.253,0h-3.517l-9.018.045h-.09V353.1h0l.09-.09h12.571v3.679A1.345,1.345,0,0,1,224.513,357.149Z",
    transform: "translate(-157.202 -276.329)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_194",
    "data-name": "Path 194",
    d: "M307.037,364.659V360.79l.054.054H294.52l.09-.09h0v3.86l-.09-.09,8.964.045h3.607a.991.991,0,0,1-.234,0H294.43v-3.95h0l.1-.1h12.634V364.2a1.19,1.19,0,0,1-.126.46Z",
    transform: "translate(-165.3 -277.067)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_195",
    "data-name": "Path 195",
    d: "M307.919,368.913a2.094,2.094,0,0,1,0-.289v-.785c0-.8-.045-1.722-.063-2.76l.081.081h-4.68l.1-.1h0v3.8l-.081-.081h4.671a2.066,2.066,0,0,1-.325,0H303.23V364.9h0l.09-.09h4.753v3.643a1.244,1.244,0,0,1-.153.46Z",
    transform: "translate(-166.164 -277.488)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_196",
    "data-name": "Path 196",
    d: "M272.438,357.14a1.546,1.546,0,0,1,0-.271v-3.6l.054.063H259.921c.045,0-.1.1.09-.09h0v3.86l-.09-.09,8.964.045H272.5a1.2,1.2,0,0,1-.234,0H259.84v-3.95h0l.1-.1h12.634V356.7A.917.917,0,0,1,272.438,357.14Z",
    transform: "translate(-161.904 -276.329)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_35",
    "data-name": "Group 35",
    transform: "translate(104.24 73.064)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_66",
    "data-name": "Rectangle 66",
    width: 12.58,
    height: 3.869,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_36",
    "data-name": "Group 36",
    transform: "translate(135.019 54.604)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_67",
    "data-name": "Rectangle 67",
    width: 7.097,
    height: 3.869,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_197",
    "data-name": "Path 197",
    d: "M205.329,382.608V378.73l.063.063H192.821c0-.045-.1.09.09-.1h0v3.86l-.1-.09h9.036l-9.018.045h-.09v-3.95h0c.189-.189.054-.045.1-.09h12.634v3.679A1.308,1.308,0,0,1,205.329,382.608Z",
    transform: "translate(-155.315 -278.828)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_198",
    "data-name": "Path 198",
    d: "M199.238,387.054v-3.869l.054.054H186.721l.09-.09h0v3.86l-.09-.09h12.571a.784.784,0,0,1-.225,0H186.64v-3.95h0l.1-.1h12.634v3.679a1.19,1.19,0,0,1-.135.505Z",
    transform: "translate(-154.716 -279.261)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_37",
    "data-name": "Group 37",
    transform: "translate(54.478 118.831)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_68",
    "data-name": "Rectangle 68",
    width: 6.024,
    height: 3.869,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_199",
    "data-name": "Path 199",
    d: "M243,377.959h5.023l-.09.09V374.18l.09.09H243a1.487,1.487,0,0,1,.37,0h4.743v4.049H243.37a1.488,1.488,0,0,1-.37-.361Z",
    transform: "translate(-160.25 -278.408)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_200",
    "data-name": "Path 200",
    d: "M240.2,331.851a1.579,1.579,0,0,1,.37,0h4.653l-.09.09V328l.09.09H240.57a1.577,1.577,0,0,1-.37,0,2.078,2.078,0,0,1,.37,0h4.744v4.058H240.57Z",
    transform: "translate(-159.975 -273.874)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_69",
    "data-name": "Rectangle 69",
    width: 34.801,
    height: 21.553,
    transform: "translate(95.97 90.433)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_201",
    "data-name": "Path 201",
    d: "M268.774,390.021c-.126,0-.234-4.87-.234-10.885s.108-10.876.234-10.876.234,4.87.234,10.876S268.955,390.021,268.774,390.021Z",
    transform: "translate(-162.758 -277.827)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_202",
    "data-name": "Path 202",
    d: "M284.824,390.021c-.126,0-.234-4.87-.234-10.885s.108-10.876.234-10.876.234,4.87.234,10.876S284.96,390.021,284.824,390.021Z",
    transform: "translate(-164.334 -277.827)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_203",
    "data-name": "Path 203",
    d: "M283.279,381.021a54.764,54.764,0,0,1-7.214.234,54.836,54.836,0,0,1-7.214-.234,56.825,56.825,0,0,1,7.214-.234,56.684,56.684,0,0,1,7.214.234Z",
    transform: "translate(-162.788 -279.054)",
    fill: "#407bff"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "freepik--house-1--inject-51",
    transform: "translate(0 52.639)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_204",
    "data-name": "Path 204",
    d: "M125.811,161.15H111.589L60.7,210.389V387.053H93.95Z",
    transform: "translate(-52.701 -161.15)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_205",
    "data-name": "Path 205",
    d: "M97.243,315.228a1.2,1.2,0,0,1,0-.234c0-.171,0-.4,0-.667v-2.552c0-2.236,0-5.411-.063-9.433,0-8.017-.063-19.19-.108-31.96l.234.234H85.258c.469-.469.135-.117.234-.216h0v25.44c0,7.629-.045,14.258-.063,19.38l-.144-.144,8.793.081H97.27a.767.767,0,0,1-.189,0H94.159l-8.874.081h-.144v-.144c0-5.122,0-11.724-.063-19.38v-25.44h0c.108-.108-.234.216.234-.253H97.469v.225c0,12.833-.072,24.069-.1,32.122,0,3.968-.054,7.151-.063,9.379v3.138A1.14,1.14,0,0,1,97.243,315.228Z",
    transform: "translate(-55.093 -171.84)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_206",
    "data-name": "Path 206",
    d: "M97.019,275.141a37.713,37.713,0,0,1-5.889.234,37.546,37.546,0,0,1-5.88-.234,37.546,37.546,0,0,1,5.88-.234A37.709,37.709,0,0,1,97.019,275.141Z",
    transform: "translate(-55.112 -172.317)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_207",
    "data-name": "Path 207",
    d: "M97.019,279.221a35.774,35.774,0,0,1-5.889.243,35.612,35.612,0,0,1-5.88-.243,37.539,37.539,0,0,1,5.88-.234A37.709,37.709,0,0,1,97.019,279.221Z",
    transform: "translate(-55.112 -172.718)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_208",
    "data-name": "Path 208",
    d: "M97.019,283.311a37.717,37.717,0,0,1-5.889.234,37.542,37.542,0,0,1-5.88-.234,36.269,36.269,0,0,1,5.88-.234A36.432,36.432,0,0,1,97.019,283.311Z",
    transform: "translate(-55.112 -173.119)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_209",
    "data-name": "Path 209",
    d: "M97.019,287.391a36.436,36.436,0,0,1-5.889.234,36.273,36.273,0,0,1-5.88-.234,37.542,37.542,0,0,1,5.88-.234A37.706,37.706,0,0,1,97.019,287.391Z",
    transform: "translate(-55.112 -173.52)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_210",
    "data-name": "Path 210",
    d: "M97.019,291.481a37.713,37.713,0,0,1-5.889.234,37.538,37.538,0,0,1-5.88-.234,36.269,36.269,0,0,1,5.88-.234A36.432,36.432,0,0,1,97.019,291.481Z",
    transform: "translate(-55.112 -173.921)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_211",
    "data-name": "Path 211",
    d: "M97.019,295.561a37.713,37.713,0,0,1-5.889.234,37.546,37.546,0,0,1-5.88-.234,37.549,37.549,0,0,1,5.88-.234A37.717,37.717,0,0,1,97.019,295.561Z",
    transform: "translate(-55.112 -174.322)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_212",
    "data-name": "Path 212",
    d: "M97.019,299.641a36.436,36.436,0,0,1-5.889.234,36.276,36.276,0,0,1-5.88-.234,37.546,37.546,0,0,1,5.88-.234,37.713,37.713,0,0,1,5.889.235Z",
    transform: "translate(-55.112 -174.723)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_213",
    "data-name": "Path 213",
    d: "M97.019,303.731a37.717,37.717,0,0,1-5.889.234,37.542,37.542,0,0,1-5.88-.234,36.266,36.266,0,0,1,5.88-.235,36.432,36.432,0,0,1,5.889.234Z",
    transform: "translate(-55.112 -175.124)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_214",
    "data-name": "Path 214",
    d: "M97.019,307.811a36.436,36.436,0,0,1-5.889.234,36.266,36.266,0,0,1-5.88-.234,37.542,37.542,0,0,1,5.88-.234,37.713,37.713,0,0,1,5.889.234Z",
    transform: "translate(-55.112 -175.525)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_215",
    "data-name": "Path 215",
    d: "M97.019,311.9a37.713,37.713,0,0,1-5.889.234,37.542,37.542,0,0,1-5.88-.234,35.618,35.618,0,0,1,5.88-.243,35.771,35.771,0,0,1,5.889.243Z",
    transform: "translate(-55.112 -175.926)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_216",
    "data-name": "Path 216",
    d: "M97.019,315.971a37.717,37.717,0,0,1-5.889.234,37.542,37.542,0,0,1-5.88-.234,37.549,37.549,0,0,1,5.88-.234A37.709,37.709,0,0,1,97.019,315.971Z",
    transform: "translate(-55.112 -176.327)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_217",
    "data-name": "Path 217",
    d: "M96.6,366.438a1.2,1.2,0,0,1,0-.234c0-.171,0-.4,0-.667v-2.552c0-2.236,0-5.411-.063-9.433,0-8.017-.063-19.19-.1-31.96l.225.234H84.626c.46-.469.126-.117.225-.216h0v25.44c0,7.629-.054,14.258-.072,19.38l-.144-.144,8.793.081h.09l-8.883.081h-.144V366.3c0-5.122,0-11.724-.063-19.38v-25.44h0c.108-.108-.234.216.243-.253H96.837v.225c0,12.842-.081,24.069-.108,32.122,0,3.968-.054,7.151-.063,9.379v3.138A.893.893,0,0,1,96.6,366.438Z",
    transform: "translate(-55.029 -176.869)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_218",
    "data-name": "Path 218",
    d: "M96.379,326.351a36.342,36.342,0,0,1-5.889.234,36.269,36.269,0,0,1-5.88-.234,37.542,37.542,0,0,1,5.88-.234,37.616,37.616,0,0,1,5.889.234Z",
    transform: "translate(-55.049 -177.346)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_219",
    "data-name": "Path 219",
    d: "M96.379,330.44a37.612,37.612,0,0,1-5.889.234,37.542,37.542,0,0,1-5.88-.234,35.612,35.612,0,0,1,5.88-.243A35.687,35.687,0,0,1,96.379,330.44Z",
    transform: "translate(-55.049 -177.746)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_220",
    "data-name": "Path 220",
    d: "M96.379,334.521a37.616,37.616,0,0,1-5.889.234,37.539,37.539,0,0,1-5.88-.234,37.542,37.542,0,0,1,5.88-.234,37.62,37.62,0,0,1,5.889.235Z",
    transform: "translate(-55.049 -178.148)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221",
    "data-name": "Path 221",
    d: "M96.379,338.6a36.342,36.342,0,0,1-5.889.234,36.269,36.269,0,0,1-5.88-.234,37.542,37.542,0,0,1,5.88-.234,37.62,37.62,0,0,1,5.889.235Z",
    transform: "translate(-55.049 -178.549)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_222",
    "data-name": "Path 222",
    d: "M96.379,342.691a37.612,37.612,0,0,1-5.889.235,37.546,37.546,0,0,1-5.88-.235,36.269,36.269,0,0,1,5.88-.234,36.342,36.342,0,0,1,5.889.234Z",
    transform: "translate(-55.049 -178.95)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_223",
    "data-name": "Path 223",
    d: "M96.379,346.771a37.612,37.612,0,0,1-5.889.234,37.542,37.542,0,0,1-5.88-.234,37.542,37.542,0,0,1,5.88-.234,37.613,37.613,0,0,1,5.889.234Z",
    transform: "translate(-55.049 -179.351)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_224",
    "data-name": "Path 224",
    d: "M96.379,350.851a36.335,36.335,0,0,1-5.889.234,36.269,36.269,0,0,1-5.88-.235,37.539,37.539,0,0,1,5.88-.234,37.62,37.62,0,0,1,5.889.234Z",
    transform: "translate(-55.049 -179.751)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_225",
    "data-name": "Path 225",
    d: "M96.379,354.971a37.616,37.616,0,0,1-5.889.234,37.546,37.546,0,0,1-5.88-.234,36.266,36.266,0,0,1,5.88-.234A36.346,36.346,0,0,1,96.379,354.971Z",
    transform: "translate(-55.049 -180.156)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_226",
    "data-name": "Path 226",
    d: "M96.379,359.021a36.349,36.349,0,0,1-5.889.234,36.276,36.276,0,0,1-5.88-.234,37.542,37.542,0,0,1,5.88-.234,37.616,37.616,0,0,1,5.889.235Z",
    transform: "translate(-55.049 -180.554)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_227",
    "data-name": "Path 227",
    d: "M96.379,363.111a37.612,37.612,0,0,1-5.889.234,37.546,37.546,0,0,1-5.88-.234,36.266,36.266,0,0,1,5.88-.234,36.346,36.346,0,0,1,5.889.234Z",
    transform: "translate(-55.049 -180.955)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_228",
    "data-name": "Path 228",
    d: "M96.379,367.191a37.612,37.612,0,0,1-5.889.234,37.542,37.542,0,0,1-5.88-.235,37.546,37.546,0,0,1,5.88-.234,37.616,37.616,0,0,1,5.889.235Z",
    transform: "translate(-55.049 -181.356)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_229",
    "data-name": "Path 229",
    d: "M162.41,387.539V210.974L129.35,167.11,97.57,210.974V387.638h64.84",
    transform: "translate(-56.321 -161.735)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_230",
    "data-name": "Path 230",
    d: "M148.067,405.972v-3.481c0-2.282,0-5.546-.072-9.622,0-8.234-.045-19.7-.081-32.844l.225.225H122.392l.234-.225c0,13.139-.063,24.619-.081,32.844,0,4.076-.054,7.341-.072,9.631v3.246a.713.713,0,0,1,0,.225V402.5c0-2.291,0-5.555-.072-9.631,0-8.224,0-19.7-.081-32.844v-.234h26.152v.234c0,13.139-.063,24.61-.081,32.844,0,4.076-.054,7.341-.072,9.622v3.256a.713.713,0,0,1-.253.226Z",
    transform: "translate(-58.752 -180.655)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_231",
    "data-name": "Path 231",
    d: "M146.886,386.4c.045.054-.189.253-.162.658a.767.767,0,0,0,.28.559.613.613,0,0,0,.685,0,.631.631,0,0,0,.334-.6.794.794,0,0,0-.361-.514c-.343-.216-.631-.108-.658-.171s.271-.325.8-.126a1.064,1.064,0,0,1,.64.73,1.082,1.082,0,0,1-1.713,1.019,1.046,1.046,0,0,1-.334-.9C146.471,386.483,146.877,386.338,146.886,386.4Z",
    transform: "translate(-61.115 -183.242)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_70",
    "data-name": "Rectangle 70",
    width: 11.137,
    height: 3.463,
    transform: "translate(71.035 172.326)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_71",
    "data-name": "Rectangle 71",
    width: 20.02,
    height: 38.57,
    transform: "translate(52.079 119.012)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_232",
    "data-name": "Path 232",
    d: "M121.274,335.781c-.126,0-.234-10.073-.234-22.491s.108-22.5.234-22.5.234,10.073.234,22.5S121.41,335.781,121.274,335.781Z",
    transform: "translate(-58.626 -173.88)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_233",
    "data-name": "Path 233",
    d: "M131.16,307.974c0,.135-5.122.234-11.435.234s-11.435-.1-11.435-.234,5.113-.234,11.435-.234S131.16,307.83,131.16,307.974Z",
    transform: "translate(-57.374 -175.544)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_234",
    "data-name": "Path 234",
    d: "M131.16,323.253c0,.126-5.122.234-11.435.234s-11.435-.108-11.435-.234,5.149-.253,11.462-.253S131.16,323.117,131.16,323.253Z",
    transform: "translate(-57.374 -177.042)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_72",
    "data-name": "Rectangle 72",
    width: 20.02,
    height: 38.57,
    transform: "translate(77.97 119.012)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_235",
    "data-name": "Path 235",
    d: "M149.974,335.781c-.135,0-.234-10.073-.234-22.491s.1-22.5.234-22.5.234,10.073.234,22.5S150.119,335.781,149.974,335.781Z",
    transform: "translate(-61.444 -173.88)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_236",
    "data-name": "Path 236",
    d: "M159.87,307.974c0,.135-5.122.234-11.435.234S137,308.092,137,307.974s5.122-.234,11.435-.234S159.87,307.83,159.87,307.974Z",
    transform: "translate(-60.193 -175.544)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_237",
    "data-name": "Path 237",
    d: "M159.87,323.254c0,.126-5.122.234-11.435.234S137,323.381,137,323.254s5.122-.234,11.435-.234S159.87,323.119,159.87,323.254Z",
    transform: "translate(-60.193 -177.044)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_73",
    "data-name": "Rectangle 73",
    width: 20.02,
    height: 38.57,
    transform: "translate(52.079 64.082)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_238",
    "data-name": "Path 238",
    d: "M121.274,274.866c-.126,0-.234-10.073-.234-22.491s.108-22.545.234-22.545.234,10.073.234,22.545S121.41,274.866,121.274,274.866Z",
    transform: "translate(-58.626 -167.894)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_239",
    "data-name": "Path 239",
    d: "M131.16,247.044c0,.135-5.122.234-11.435.234s-11.435-.1-11.435-.234,5.113-.234,11.435-.234S131.16,246.918,131.16,247.044Z",
    transform: "translate(-57.374 -169.561)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240",
    "data-name": "Path 240",
    d: "M131.16,262.344c0,.126-5.122.234-11.435.234s-11.435-.108-11.435-.234,5.113-.234,11.435-.234S131.16,262.218,131.16,262.344Z",
    transform: "translate(-57.374 -171.064)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_74",
    "data-name": "Rectangle 74",
    width: 20.02,
    height: 38.57,
    transform: "translate(77.97 64.082)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241",
    "data-name": "Path 241",
    d: "M149.974,274.866c-.135,0-.234-10.073-.234-22.491s.1-22.545.234-22.545.234,10.073.234,22.545S150.119,274.866,149.974,274.866Z",
    transform: "translate(-61.444 -167.894)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_242",
    "data-name": "Path 242",
    d: "M159.87,247.044c0,.135-5.122.234-11.435.234S137,247.18,137,247.044s5.122-.234,11.435-.234S159.87,246.918,159.87,247.044Z",
    transform: "translate(-60.193 -169.561)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_243",
    "data-name": "Path 243",
    d: "M159.87,262.344c0,.126-5.122.234-11.435.234S137,262.471,137,262.344s5.122-.234,11.435-.234S159.87,262.218,159.87,262.344Z",
    transform: "translate(-60.193 -171.064)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_75",
    "data-name": "Rectangle 75",
    width: 15.773,
    height: 17.504,
    transform: "translate(25.467 142.486)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_76",
    "data-name": "Rectangle 76",
    width: 15.773,
    height: 17.504,
    transform: "translate(25.467 86.321)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_12",
    "data-name": "Ellipse 12",
    cx: 10.56,
    cy: 10.56,
    r: 10.56,
    transform: "translate(59.511 41.415) rotate(-49.01)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_244",
    "data-name": "Path 244",
    d: "M143.654,205.894c0,.126-5.023.234-11.228.234s-11.237-.108-11.237-.234,5.032-.234,11.237-.234S143.654,205.759,143.654,205.894Z",
    transform: "translate(-58.641 -165.521)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_245",
    "data-name": "Path 245",
    d: "M134.174,217.7c-.126,0-.234-5.726-.234-12.788s.108-12.8.234-12.8.234,5.726.234,12.8S134.31,217.7,134.174,217.7Z",
    transform: "translate(-59.893 -164.191)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_246",
    "data-name": "Path 246",
    d: "M97.015,210.389h-5.1l36.956-49.239,36.956,49.239h-3.977l-33.06-43.864Z",
    transform: "translate(-55.767 -161.15)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_77",
    "data-name": "Rectangle 77",
    width: 24.881,
    height: 17.504,
    transform: "translate(0.586 86.321)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_78",
    "data-name": "Rectangle 78",
    width: 24.881,
    height: 17.504,
    transform: "translate(0.586 142.486)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247",
    "data-name": "Path 247",
    d: "M77.361,210.389H52.48L90.834,161.15H125Z",
    transform: "translate(-51.894 -161.15)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_248",
    "data-name": "Path 248",
    d: "M78.614,338.824c0,.126-6,.234-13.392.234s-13.392-.108-13.392-.234,5.988-.234,13.392-.234S78.614,338.689,78.614,338.824Z",
    transform: "translate(-51.83 -178.573)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_249",
    "data-name": "Path 249",
    d: "M78.614,319.124c0,.135-6,.234-13.392.234s-13.392-.1-13.392-.234,5.988-.234,13.392-.234S78.614,318.989,78.614,319.124Z",
    transform: "translate(-51.83 -176.639)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_250",
    "data-name": "Path 250",
    d: "M78.614,276.684c0,.135-6,.234-13.392.234s-13.392-.1-13.392-.234,5.988-.234,13.392-.234S78.614,276.558,78.614,276.684Z",
    transform: "translate(-51.83 -172.472)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_251",
    "data-name": "Path 251",
    d: "M78.614,257.2c0,.126-6,.234-13.392.234s-13.392-.108-13.392-.234,5.988-.234,13.392-.234S78.614,257.069,78.614,257.2Z",
    transform: "translate(-51.83 -170.559)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_252",
    "data-name": "Path 252",
    d: "M117.456,353.3v-4.509l.063.063H102.9s-.09.1.1-.09h0v4.482l-.09-.09h14.618a1.163,1.163,0,0,1-.271,0H102.82V348.58h0l.09-.09h14.681v4.293A1.2,1.2,0,0,1,117.456,353.3Z",
    transform: "translate(-56.837 -179.545)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_253",
    "data-name": "Path 253",
    d: "M124.964,348.3v-4.518l.054.063H110.409c0-.045-.1.09.09-.1h0v4.509l-.1-.09h14.618a1.418,1.418,0,0,1-.271,0H110.31v-4.581h0c.189-.189.054-.054.1-.09h14.672v4.293A1.282,1.282,0,0,1,124.964,348.3Z",
    transform: "translate(-57.572 -179.053)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_254",
    "data-name": "Path 254",
    d: "M119.105,292.6v-4.509l.063.063H104.55l.09-.09h0v4.509l-.09-.09,10.425.045H104.46v-4.572h0c.189-.189.054-.054.1-.09h14.672v4.293A.8.8,0,0,1,119.105,292.6Z",
    transform: "translate(-56.998 -173.591)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_255",
    "data-name": "Path 255",
    d: "M162.235,222.1v-4.509l.063.054H147.68l.09-.09h0v4.509l-.09-.09h10.488l-10.488.045h-.09v-4.581h0l.1-.1h14.672v4.293A.954.954,0,0,1,162.235,222.1Z",
    transform: "translate(-61.233 -166.667)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_256",
    "data-name": "Path 256",
    d: "M122.265,193.974v-4.509l.054.054H107.7s-.09.1.1-.09h0v4.482l-.09-.09h-.09v-4.572h0c.189-.189.054-.054.09-.1h14.681v4.293A1.4,1.4,0,0,1,122.265,193.974Z",
    transform: "translate(-57.308 -163.899)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_257",
    "data-name": "Path 257",
    d: "M107.985,269.971v-4.518l.063.063H93.43s-.1.09.09-.1h0v4.509l-.09-.09,10.425.045h.063l-10.488.045h-.09v-4.437h0c.189-.189.054-.045.1-.09h14.681v4.293C108.121,269.971,107.985,269.971,107.985,269.971Z",
    transform: "translate(-55.906 -171.385)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_258",
    "data-name": "Path 258",
    d: "M101.514,264.883v-4.518l.054.063H86.95s-.09.1.1-.09h0v4.509l-.1-.09,10.434.045h4.184a1.166,1.166,0,0,1-.271,0H86.86V260.23h0l.09-.09h14.681v4.293A.892.892,0,0,1,101.514,264.883Z",
    transform: "translate(-55.27 -170.87)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_259",
    "data-name": "Path 259",
    d: "M167.717,366.278v-4.509l.063.054H153.162l.09-.09h0v4.509l-.09-.09H153v-4.572h0l.1-.1h14.672v4.293A2.52,2.52,0,0,1,167.717,366.278Z",
    transform: "translate(-61.764 -180.821)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_260",
    "data-name": "Path 260",
    d: "M164.006,283.717V279.19l.063.063H149.451l.1-.1h0v4.491l-.09-.1,10.425.045H149.37v-4.581h0c.189-.18.054-.045.09-.09h14.681v4.293A1.089,1.089,0,0,1,164.006,283.717Z",
    transform: "translate(-61.408 -172.713)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_261",
    "data-name": "Path 261",
    d: "M168.7,371.251a1.379,1.379,0,0,1,0-.334v-4.148l.081.081h-5.663l.1-.1h0v4.482l-.09-.081,4.067.045h.054l-4.121.045H163V366.67h0c-.081.09.117-.108.09-.09h5.735v4.266A.588.588,0,0,1,168.7,371.251Z",
    transform: "translate(-62.744 -181.322)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_262",
    "data-name": "Path 262",
    d: "M168.7,288.72a1.578,1.578,0,0,1,0-.343v-4.139l.081.072h-5.663s.18-.18.1-.09h0V288.7l-.09-.09,4.067.045h.054l-4.121.045H163v-4.563h0c-.081.081.117-.117.09-.1h5.735v4.275A.588.588,0,0,1,168.7,288.72Z",
    transform: "translate(-62.744 -173.217)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_79",
    "data-name": "Rectangle 79",
    width: 26.387,
    height: 13.031,
    transform: "translate(106.089 212.872)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_263",
    "data-name": "Path 263",
    d: "M95.007,215.71c0,.135-9.469.189-21.138.126s-21.138-.216-21.138-.343,9.46-.189,21.138-.126S95.007,215.584,95.007,215.71Z",
    transform: "translate(-51.918 -166.471)",
    fill: "#455a64"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCity);
export default __webpack_public_path__ + "static/media/city.8c7c8055f9e1ac670b5abdd2ce6fd7a7.svg";
export { ForwardRef as ReactComponent };